import React, { Component } from "react";
import PropTypes from 'prop-types';
import UserService from '../../../Services/UserService';

class ProjectUserPref extends Component {
  static propTypes = {
    projectId: PropTypes.number.isRequired
  }

  constructor() {
    super();
    this.state = {
      isLoading: true,
      isProjectPref: false
    };
  }
  componentDidMount() {
    // request overview data
    const id = this.props.projectId;

    if (id) {
      UserService.IsPrefProject(id)
        .then(check => {
          this.setState({ isProjectPref: check, isLoading: false });
        });
      UserService.subscribePrefProjects(this.handleMyPrefsUpdated);
    }
  }

  componentWillUnmount() {
    UserService.unsubscribePrefProjects(this.handleMyPrefsUpdated);
  }

  handleMyPrefsUpdated = () => {
    UserService.IsPrefProject(this.props.projectId)
      .then(check => { this.setState({ isProjectPref: check, isLoading: false }); });
  }


  updateProjectUserPref = (event, wantToPref) => {
    event.preventDefault();
    event.stopPropagation();

    var action = wantToPref === true ? UserService.AddPrefProjects(this.props.projectId) : UserService.RemovePrefProjects(this.props.projectId);
    action.then(() => {
      this.setState({ isProjectPref: wantToPref, isLoading: false });
    });
  }

  render() {
    if (this.state.isLoading) {
      return (null);
    }

    return (
      <div className='userProjectPref' onClick={(e) => this.updateProjectUserPref(e, !this.state.isProjectPref)} title="Add/remove to your favourite(s)">
        {this.state.isProjectPref ? (
          <i className="icon-star-fg icon-star-bg active"></i>
        ) : (
          <i className="icon-star-fg icon-star-bg"></i>
          )}
      </div>
    );
  }
}

export default ProjectUserPref;
